const homeTitle = document.querySelector<HTMLElement>('.home-title');

document.addEventListener('DOMContentLoaded', () => {
    if (homeTitle) {
        typewriterEffect(homeTitle);
    }
})

function typewriterEffect(textElement: HTMLElement) {
    const text = textElement.innerHTML;
    const textHeight = textElement.offsetHeight;
    textElement.style.height = textHeight + 'px';
    textElement.innerHTML = '';

    let index = 0;
    const intervalId = setInterval(() => {
        textElement.innerHTML += text[index] === ' ' ? '<br/>' : text[index];
        index++;

        if (index >= text.length) {
            clearInterval(intervalId);
        }
    }, 70);
}